"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _selectors = require("../../redux/selectors");
var _material = require("@mui/material");
var _function = require("../../utils/function");
var _devices = require("../../redux/actions/devices");
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Tabs = _ref => {
  let {
    chartId,
    equipmentKey
  } = _ref;
  const [activeTab, setActiveTab] = (0, _react.useState)(0);
  const dispatch = (0, _reactRedux.useDispatch)();
  const groupListPwh = Object.values((0, _reactRedux.useSelector)(_selectors.selectPwhCByHtgSys));
  const groupListHx = Object.values((0, _reactRedux.useSelector)(_selectors.selectHxList));
  const groupList = equipmentKey === _constants.keysForGroupChartsById.Pwh ? groupListPwh : groupListHx;
  const activeGroup = (0, _reactRedux.useSelector)((0, _selectors.selectActiveGroup)(chartId));
  const handleChangeTab = (e, newValue) => {
    setActiveTab(newValue);
    const activeGroup = (groupList === null || groupList === void 0 ? void 0 : groupList.find((_, i) => i === newValue)) || null;
    dispatch((0, _devices.setActiveGroup)({
      chartId,
      equipmentKey,
      group: activeGroup
    }));
  };
  (0, _react.useEffect)(() => {
    groupList === null || groupList === void 0 || groupList.map((group, index) => group.id === activeGroup && setActiveTab(index));
  }, [activeGroup]);
  const tV = (0, _paulCorePackage.useTranslationValue)();
  const {
    [23]: tGroup = ''
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: 9,
      mb: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_paulCorePackage.Tabs, {
    value: activeTab,
    onChange: handleChangeTab,
    variant: "scrollable",
    scrollButtons: "auto",
    "aria-label": "Circulation group tabs",
    sx: {
      '& .MuiTab-root': {
        fontFamily: "var(--main-font-family) !important",
        fontWeight: 'bold'
      }
    }
  }, groupList === null || groupList === void 0 ? void 0 : groupList.map((group, index) => /*#__PURE__*/_react.default.createElement(_paulCorePackage.Tab, {
    key: group.id,
    label: (0, _function.getGroupName)({
      tGroup,
      name: tV(group === null || group === void 0 ? void 0 : group.thingInfoDesignation),
      index
    }),
    index: index
  }))));
};
var _default = exports.default = Tabs;